// src/redux/schedule/scheduleThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://your-backend-url.com';

// CREATE schedule
export const createSchedule = createAsyncThunk(
    'schedule/createSchedule',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BASE_URL}/scheduler/create`, payload, {
                headers: {
                    Authorization: `Bearer ${Cookies.get('token')}`,
                },
            });
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Failed to create schedule');
        }
    }
);

// DELETE schedule
export const deleteSchedule = createAsyncThunk(
    'schedule/deleteSchedule',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${BASE_URL}/scheduler/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get('token')}`,
                },
            });
            return { id, ...response.data };
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Failed to delete schedule');
        }
    }
);

// Fetch schedules by conversationId
export const fetchSchedulesByConversationId = createAsyncThunk(
    'schedule/fetchSchedulesByConversationId',
    async (conversationId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BASE_URL}/scheduler/${conversationId}`,{
                headers: {
                    Authorization: `Bearer ${Cookies.get('token')}`,
                },
            });
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to fetch schedules");
        }
    }
);